import { create } from "zustand";

export interface CompletionOrigin {
  x: number;
  y: number;
}

interface CompletionLaunch {
  id: number;
  origin: CompletionOrigin | null;
}

interface CompletionCelebrationState {
  launchId: number;
  launches: CompletionLaunch[];
  launch: (origin?: CompletionOrigin | null) => void;
}

const ORIGIN_MAX_AGE_MS = 1500;
let recentPointer: { origin: CompletionOrigin; at: number } | null = null;

export function rememberCompletionPointer(origin: CompletionOrigin, now = performance.now()): void {
  recentPointer = { origin, at: now };
}

export function clearCompletionPointer(): void {
  recentPointer = null;
}

export function recentCompletionOrigin(now = performance.now()): CompletionOrigin | null {
  if (!recentPointer || now - recentPointer.at > ORIGIN_MAX_AGE_MS) return null;
  return recentPointer.origin;
}

/** A monotonic signal rather than a boolean so rapid completions never collapse
 * into an unobservable true -> true update. The canvas owns all visual state. */
export const useCompletionCelebrationStore = create<CompletionCelebrationState>((set) => ({
  launchId: 0,
  launches: [],
  launch: (origin = null) => set((state) => {
    const id = state.launchId + 1;
    return {
      launchId: id,
      launches: [...state.launches.slice(-31), { id, origin }],
    };
  }),
}));
